<template>
    <NuxtLayout name="malt-full-layout">
        <main>
            <slot />
        </main>
    </NuxtLayout>
</template>
